module.exports = __webpack_public_path__ + "img/main-banner.0b6a2bd0.jpg";